import config from '../config.json'
import FileDTO, {IFile} from './FileDTO'
import TagDTO, {ITag} from './TagDTO'

export enum FileListMode {
  manage,
  selectPicture,
  manageWatermarks,
  selectWatermark,
}

export const FileListMode2Kind = [
  [FileListMode.manage, 1],
  [FileListMode.selectPicture, 1],
  [FileListMode.manageWatermarks, 4],
  [FileListMode.selectWatermark, 4],
]

export function getKindFromFileListMode(fileListMode: FileListMode): number {
  const translate = FileListMode2Kind.find(item => item[0] === fileListMode)
  if (translate) {
    return translate[1]
  }
  return 1
}

type GetOptions = {
  fresh?: boolean
  id?: number
}
export default class FilesDTO {
  private files: FileDTO[] = []
  private mode: FileListMode

  constructor(options: {mode: FileListMode}) {
    this.mode = options.mode
  }

  init(o: {files: IFile[], tagList: ITag[]}): FileDTO[] {
    if (!o.tagList) {
      return []
    }
    const tags = o.tagList.map((t) => new TagDTO(t))
    this.files = o.files.map((f: IFile) => new FileDTO(f, {tags: tags}))
    return this.files
  }

  private getKind(): number {
    return getKindFromFileListMode(this.mode)
  }

  async get(o?: GetOptions): Promise <FileDTO[]> {
    if (this.files.length === 0 || (o && o.fresh)) {
      const response = await fetch(`${config.apiPrefix}groupadmin/Files/getAll`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ kind: this.getKind() })
      })
      let responseJson = await response.json()
      this.init(responseJson)
    }
    return this.files
  }

  getSingle(id: number): FileDTO {
    const result = this.files.find((f) => f.id === id)
    if (!result) {
      return new FileDTO()
    }
    return result
  }
}
